/**
 * @file ColumnMapper.tsx
 * @description A component for mapping columns from an imported spreadsheet to application columns.
 * This component allows users to select which imported columns correspond to which application fields.
 */

import React, { useState, useEffect } from "react";

interface ColumnMapperProps {
  sheetColumns: string[];
  appColumns: string[];
  onColumnMapped: (mappedColumns: Record<string, string>) => void;
  initialMappings?: Record<string, string>;
}

const ColumnMapper: React.FC<ColumnMapperProps> = ({
  sheetColumns,
  appColumns,
  onColumnMapped,
  initialMappings,
}) => {
  const [mappings, setMappings] = useState<Record<string, string>>(
    initialMappings || {}
  );

  useEffect(() => {
    onColumnMapped(mappings);
  }, [mappings, onColumnMapped]);

  const handleMappingChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
    sheetColumn: string
  ) => {
    const appColumn = event.target.value;
    setMappings((prev) => ({ ...prev, [sheetColumn]: appColumn }));
  };

  return (
    <>
      <div className="divider" />
      <p>
        Per favore seleziona a quale colonna del piano editoriale corrisponde
        ciascuna colonna del file Excel.
      </p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {sheetColumns.map((sheetColumn) => (
          <div key={sheetColumn} className="w-full form-control">
            <label className="font-medium normal-case label">
              <span className="label-text text-primary">{sheetColumn}</span>
            </label>
            <select
              className="w-full bg-transparent select select-bordered rounded-2xl"
              value={mappings[sheetColumn] || ""}
              onChange={(e) => handleMappingChange(e, sheetColumn)}
            >
              <option value="">Non importare</option>
              {appColumns.map((appColumn) => (
                <option key={appColumn} value={appColumn}>
                  {appColumn}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </>
  );
};

export default ColumnMapper;
